import { render, staticRenderFns } from "./__recreate.vue?vue&type=template&id=768c97cb&scoped=true&"
import script from "./__recreate.vue?vue&type=script&lang=js&"
export * from "./__recreate.vue?vue&type=script&lang=js&"
import style0 from "./__recreate.vue?vue&type=style&index=0&id=768c97cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c97cb",
  null
  
)

export default component.exports